import React from 'react';
import {NavLink} from 'react-router-dom';

const SingedOutLinks =()=>{
    return(
    
        
    
       <div>
        
            <li><NavLink to="/Singin">Sign In</NavLink></li>
            <li><NavLink to="/Singup">Sign Up</NavLink></li>
            
        </div>
     
    )
}

export default SingedOutLinks;